<template>
  <div class="sidebar-filter-wrap">
    <div class="cateogary-block emb-card white mb-6 pa-6">
      <h5>{{sideSection.Categories_Label}}</h5>
      <!-- <div key="defaultCategory" class="p-field-radiobutton">
        <RadioButton
          :dir="rtlLayout?'rtl':'ltr'"
          id="defaultCategory"
          name="category"
          :value="''"
          v-model="selectedCategory"
          @change="subCategory='';updateFilter()"
        />
        <label for="defaultCategory">{{sideSection.All_Label}}</label>
      </div>
      <div v-for="(category,index) of productCategories" :key="index" class="p-field-radiobutton">
        <RadioButton
          :dir="rtlLayout?'rtl':'ltr'"
          :id="index"
          name="category"
          :value="category.Category_ID.trim()"
          v-model="selectedCategory"
          @change="subCategory='';updateFilter()"
        />
        <label :for="category.key">{{category.Category_Title}}</label>
      </div>-->

      <v-radio-group
        v-model="selectedCategory"
        id="defaultCategory"
        @change="subCategory=0;updateFilter()"
        column
      >
        <v-radio :label="sideSection.All_Label" value></v-radio>
        <v-radio
          v-for="category in productCategories"
          :label="category.Category_Title"
          :value="category.Category_ID.trim()"
          :key="category.Category_ID+'cat'"
        ></v-radio>
      </v-radio-group>
    </div>

    <div
      class="cateogary-block emb-card white mb-6 pa-6"
      v-if="categorySelected.Sub_Category && categorySelected.Sub_Category.length"
    >
      <h5>{{sideSection.Sub_Categories_Label}}</h5>

      <v-radio-group v-model="subCategory" id="defaultSubCategory" @change="updateFilter()" column>
        <v-radio :label="sideSection.All_Label" value></v-radio>
        <v-radio
          v-for="subcategory in categorySelected.Sub_Category"
          :label="subcategory.Sub_Category_Name"
          :value="subcategory.Sub_Category_ID.trim()"
          :key="subcategory.Sub_Category_ID+'sub'"
        ></v-radio>
      </v-radio-group>

      <!-- <div key="defaultSubCategory" class="p-field-radiobutton">
        <RadioButton
          :dir="rtlLayout?'rtl':'ltr'"
          id="defaultSubCategory"
          name="subCategory"
          :value="''"
          v-model="subCategory"
          @change="updateFilter()"
        />
        <label for="defaultSubCategory">{{sideSection.All_Label}}</label>
      </div>
      <div
        v-for="(subcategory,index) in categorySelected.Sub_Category"
        :key="index"
        class="p-field-radiobutton"
      >
        <RadioButton
          :dir="rtlLayout?'rtl':'ltr'"
          :id="index"
          name="subCategory"
          :value="subcategory.Sub_Category_ID.trim()"
          v-model="subCategory"
          @change="updateFilter()"
        />
        <label :for="subcategory.key">{{subcategory.Sub_Category_Name}}</label>
      </div>-->
    </div>

    <div class="emb-card white mb-6 pa-6">
      <h5>{{sideSection.Price_Label}}</h5>
      <!-- <Slider
        v-model="valueSlider"
        :range="true"
        :min="(selectedFilter[0]-5)<0?0:(selectedFilter[0]-5)"
        :max="(selectedFilter[1]+5)"
      />-->
      <v-range-slider
        v-model="valueSlider"
        :max="selectedFilter[1]"
        :min="selectedFilter[0]"
        :step="0.01"
        hide-details
        class="align-center"
      ></v-range-slider>

      <div :class="rtlLayout?'pull-right':'pull-left'">
        <span>
          {{ $n(
          valueSlider[0] / selectCurrency.CurrencyMultiplier,
          "currency",
          selectCurrency.selectedCurrency
          ) }}
        </span>
      </div>
      <div :class="rtlLayout?'pull-left':'pull-right'">
        <span>
          {{$n(
          valueSlider[1] / selectCurrency.CurrencyMultiplier,
          "currency",
          selectCurrency.selectedCurrency
          )}}
        </span>
      </div>
    </div>
    <!-- <div class="emb-card white mb-6 pa-6">
      <h5>{{sideSection.Rating_Label}}</h5>
      <Rating :value="5" :cancel="false" :dir="rtlLayout?'rtl':'ltr'" />
      <Rating :value="4" :cancel="false" />
      <Rating :value="3" :cancel="false" />
      <Rating :value="2" :cancel="false" />
      <Rating :value="1" :cancel="false" />
    </div>-->
    <!-- <div class="emb-card white pa-6">
      <div class="ais-ClearRefinements">
        <Button :label="sideSection.Clear_All_Filters_Label" />
      </div>
    </div>-->
  </div>
</template>

<script>
// import RadioButton from "primevue/radiobutton";
// import Slider from "primevue/slider";
import { mapGetters } from "vuex";
export default {
  components: {
    // RadioButton,
    // Slider,
  },
  computed: {
    ...mapGetters([
      "rtlLayout",
      "selectCurrency",
      "productCategories",
      "categorySelected",
      "selectedLocale",
      // "selectedFilterValue",
    ]),
    valueSlider: {
      get() {
        return this.$store.getters.selectedFilterValue;
      },
      set(val) {
        this.$store.dispatch("setfilterValues", val);
      },
    },
  },
  props: ["sideSection"],
  data() {
    return {
      // sideSection: "",
      selectedCategory: "",
      subCategory: "",
      selectedFilter: [],
    };
  },
  created() {
    // if (this.$route.query.category == 0) {
    //   this.selectedCategory = "";
    // } else {
    //   this.selectedCategory = this.$route.query.category
    //     ? this.$route.query.category
    //     : "" || "";
    // }
    // if (this.$route.query.subcategory == 0) {
    //   this.subCategory = "";
    // } else {
    //   this.subCategory = this.$route.query.subcategory
    //     ? this.$route.query.subcategory
    //     : "" || "";
    // }

    this.selectedCategory = this.$route.query.category
      ? this.$route.query.category.trim()
      : 0 || 0;
    this.subCategory = this.$route.query.subcategory
      ? this.$route.query.subcategory.trim()
      : 0 || 0;
  },
  mounted() {
    // setTimeout(() => {
    this.selectedFilter = this.valueSlider;
    // }, 100);
    this.updateFilter();
  },
  watch: {
    $route: {
      handler() {
        this.selectedCategory = this.$route.query.category
          ? this.$route.query.category.trim()
          : 0 || 0;
        this.subCategory = this.$route.query.subcategory
          ? this.$route.query.subcategory.trim()
          : 0 || 0;
        this.updateFilter();
      },
      deep: true,
    },
    selectedLocale() {
      setTimeout(() => {
        this.updateFilter();
      }, 500);
    },
  },
  methods: {
    updateFilter: function () {
      // this.$store.dispatch("getProducts");
      const category = {
        category: this.selectedCategory ? this.selectedCategory.trim() : 0 || 0,
        subCategory: this.subCategory ? this.subCategory.trim() : 0 || 0,
      };
      setTimeout(() => {
        this.$store.dispatch("filterProducts", category);
        this.selectedFilter = this.valueSlider;
      }, 500);
    },
  },
};
</script>